import type { App } from 'vue';
import FSelect from './f-select.vue';

export declare interface Select {
  install: (app: App) => void;
}

export function useSelect() : Select {
  return {
    install: (app: App) => {
      app.component('FSelect', FSelect);
    },
  };
}